import type { AdElement } from '@adflow/types';
import type { HitTarget } from '../../canvas/selection';

export function toHitTargets(elements: readonly AdElement[]): HitTarget[] {
  return elements
    .filter((element) => element.type !== 'SVG')
    .map((element) => ({
      id: element.id,
      z: element.position.z,
      bounds: {
        x: element.position.x,
        y: element.position.y,
        width: element.size.width,
        height: element.size.height,
      },
      locked: element.locked === true,
      hidden: element.hidden === true,
    }));
}
